const Logger = require("../Logger");
const ConfigurationFactory = require("../ConfigurationFactory");
const Config = require("../Config/Config");
const AuthenticatedStorageCDN = require("authenticated-storage-cdn-client");

let filePath;
let client;

const service = {};

const FETCH_LATEST_OPTIONS = {
  contentTypes: ["application/json", "text/json", "text/plain"],
  maxBytes: 512 * 1024
};

const getCdnClientOptions = (identity) => {
  const origin = Config.AUTHENTICATED_STORAGE_CDN_URL || "https://cdn.risevision.com";

  return Object.assign({}, identity, {
    authUrl: origin,
    cdnUrl: origin
  });
};

service.init = () => {
  filePath = undefined;
  client = undefined;

  if (window.disableViewerContentFetch) { return; }
  if (ConfigurationFactory.isWebPlayer()) { return; }
  if (ConfigurationFactory.isEmbed()) { return; }
  if (ConfigurationFactory.isPreview()) { return; }

  const id = ConfigurationFactory.getId();

  if (ConfigurationFactory.isSharedschedule()) {
    filePath = `risevision-schedule-notifications/${id}/sharedschedule.json`;
    client = AuthenticatedStorageCDN.createAuthenticatedStorageClient(getCdnClientOptions({ scheduleId: id }));
  } else {
    filePath = `risevision-display-notifications/${id}/content.json`;
    client = AuthenticatedStorageCDN.createAuthenticatedStorageClient(getCdnClientOptions({ displayId: id }));
  }
};

service.isAvailable = () => Boolean(client && filePath);

service.isCdnErrorRequiringFallback = error =>
  AuthenticatedStorageCDN.isCdnErrorRequiringFallback(error);

service.getContent = (cb) => {
  if (!service.isAvailable()) { return Promise.resolve(cb()); }

  Logger.logDebug("Retrieving GCS CDN Data " + filePath);

  return client.fetchLatest(filePath, FETCH_LATEST_OPTIONS)
  .then((response) => {
    return response.json()
    .then((result) => {
      cb(result);
    });
  });
};

module.exports = service;
